import { Injectable } from '@angular/core';

@Injectable()
export class CompoModel {

  constructor() { }
  public lib_compo:string;
  public id_catcompo:string;
}